import { PeriodOption } from '../models/Frequency/types'
import { FacilityItem } from '../hooks/useFacilitiesPlan/types'

export const SINGLE_AREA_FACILITY_ITEMS: FacilityItem[] = [
    {
        id: 'pool',
        name: 'Pool/Spa',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'tanning',
        name: 'Tanning Bed',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'sauna',
        name: 'Sauna',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'property_vehicle',
        name: 'Property Vehicle',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'shuttle_bus',
        name: 'Shuttle Bus',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'golf_cart',
        name: 'Golf Cart',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'balconies',
        name: 'Balconies',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'parking_garage',
        name: 'Parking Garage',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'sidewalks',
        name: 'Sidewalks',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'oil_water_separator',
        name: 'Oil & Water Separator',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'grease_trap',
        name: 'Grease Trap',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'water_softener',
        name: 'Water Softener System',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'water_booster',
        name: 'Water Booster Pump',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'steam_equipment',
        name: 'Steam Equipment',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'generator',
        name: 'Generator',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'trash_compactor',
        name: 'Trash Compactor',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'trash_chutes',
        name: 'Trash Chutes',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'lift_station',
        name: 'Lift Station',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'cafe',
        name: 'Cafe/Food Services',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'retail',
        name: 'Retail',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'gym_equipment',
        name: 'Gym Equipment',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'air_compressor',
        name: 'Air Compressor',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'elevator',
        name: 'Elevator',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
    {
        id: 'boiler_system',
        name: 'Boiler System',
        value: null,
        period: PeriodOption.MN,
        inspectionType: null,
        selectedUnit: null,
    },
]
